var map = {
	"./Arsenal-2-Pro-thumb": 303,
	"./Arsenal-2-Pro-thumb.jpg": 303,
	"./Arsenal-2-Standard-thumb": 304,
	"./Arsenal-2-Standard-thumb.jpg": 304,
	"./DPReview-logo": 136,
	"./DPReview-logo.png": 136,
	"./arsenal-thumb": 307,
	"./arsenal-thumb.jpg": 307,
	"./fire": 68,
	"./fire.png": 68,
	"./klarna_badge": 308,
	"./klarna_badge.jpg": 308,
	"./micro-sd-card-thumb": 309,
	"./micro-sd-card-thumb.jpg": 309,
	"./phone-mount-large": 301,
	"./phone-mount-large.jpg": 301,
	"./phone-mount-thumb": 310,
	"./phone-mount-thumb.jpg": 310,
	"./powerbank-thumb": 311,
	"./powerbank-thumb.jpg": 311,
	"./sandisk": 312,
	"./sandisk.jpg": 312,
	"./usb-powerbank-large": 302,
	"./usb-powerbank-large.jpg": 302
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 328;